
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/35a78965fe504e45f4894ff12f1e2aeb.jpg"
          alt="ゆうまデンタルクリニック"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a2540]/95 via-[#0a2540]/85 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-8">
            {/* Main Title */}
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
                <span className="block bg-gradient-to-r from-white via-[#a8c5d9] to-white bg-clip-text text-transparent">
                  最高な笑顔へ
                </span>
                <span className="block mt-2 bg-gradient-to-r from-white via-[#a8c5d9] to-white bg-clip-text text-transparent">
                  インプラントを
                </span>
                <span className="block mt-2 bg-gradient-to-r from-white via-[#a8c5d9] to-white bg-clip-text text-transparent">
                  ご提案
                </span>
              </h1>
              
              {/* New Text Lines */}
              <div className="mt-6 space-y-2">
                <p className="text-2xl lg:text-3xl font-medium text-white/90">
                  今この時から健康寿命が伸びます
                </p>
                <p className="text-xl lg:text-2xl font-light text-[#a8c5d9]">
                  さぁ共に歩んでいきましょう
                </p>
              </div>
              
              {/* Decorative Line */}
              <div className="flex items-center gap-4 pt-4">
                <div className="h-[2px] w-20 bg-gradient-to-r from-[#a8c5d9] to-transparent"></div>
                <div className="h-[2px] w-12 bg-gradient-to-r from-[#a8c5d9] to-transparent"></div>
              </div>

              {/* Price Badge */}
              <div className="inline-flex items-center gap-4 bg-gradient-to-r from-[#c8a882] to-[#b89872] rounded-2xl px-7 py-5 shadow-2xl border border-white/30 mt-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/25">
                  <i className="ri-price-tag-3-line text-white text-2xl"></i>
                </div>
                <div>
                  <p className="text-white/80 text-xs font-semibold tracking-widest uppercase mb-1">インプラント料金</p>
                  <p className="text-white font-bold leading-tight">
                    <span className="text-lg">上部構造含め</span>
                    <span className="text-4xl font-extrabold ml-2">28万円〜</span>
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <a
                href="#contact"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-[#4a90a4] to-[#5fa8bd] rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-line mr-2 text-xl w-6 h-6 flex items-center justify-center"></i>
                無料カウンセリング予約
              </a>
              <a
                href="#features"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white border-2 border-white/30 rounded-full hover:bg-white/10 hover:border-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-down-line mr-2 text-xl w-6 h-6 flex items-center justify-center"></i>
                詳しく見る
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-8 pt-8 border-t border-white/20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#4a90a4]/20">
                  <i className="ri-time-line text-2xl text-[#a8c5d9]"></i>
                </div>
                <div>
                  <p className="text-sm text-[#a8c5d9]">経験</p>
                  <p className="text-lg font-semibold">15年以上</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#4a90a4]/20">
                  <i className="ri-shield-check-line text-2xl text-[#a8c5d9]"></i>
                </div>
                <div>
                  <p className="text-sm text-[#a8c5d9]">保証</p>
                  <p className="text-lg font-semibold">10年保証</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Doctor Image */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative group">
              <img 
                src="https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/a2f13ab1360fa32ec45aa647acc344d5.png"
                alt="ゆうまデンタルクリニック 医師"
                className="w-full h-[600px] lg:h-[700px] object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2 animate-bounce">
          <p className="text-white/60 text-sm">Scroll</p>
          <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
